/**
 * Единый порядок подразделов БЗ — по числовому префиксу в названии
 * («2. Договор», «11. Подключение систем» → 2, 11). Так список разделов на
 * странице блока и дерево на странице статьи всегда идут по порядку
 * нумерации и совпадают между собой. Если переименовать раздел (сменить
 * номер) — порядок обновится автоматически.
 *
 * Логика сравнения:
 *  - оба с числом → по числу (натурально, 2 < 10 < 11);
 *  - только один с числом → нумерованный выше;
 *  - оба без числа → по алфавиту (ru).
 */
function leadingNumber(name: string): number | null {
  const m = /^\s*(\d+)/.exec(name);
  return m ? parseInt(m[1], 10) : null;
}

export function compareSectionNames(a: string, b: string): number {
  const na = leadingNumber(a);
  const nb = leadingNumber(b);
  if (na != null && nb != null) return na - nb || a.localeCompare(b, 'ru');
  if (na != null) return -1;
  if (nb != null) return 1;
  return a.localeCompare(b, 'ru');
}

/**
 * Компаратор подразделов по РУЧНОМУ порядку (`sortOrder` категории) — чтобы
 * drag-n-drop в режиме редактирования реально перемещал раздел и сохранялся.
 * `orderByName` — карта имя_категории → sortOrder (минимальный, если одно имя
 * встречается у нескольких категорий). Если у обоих имён известен sortOrder —
 * сравниваем по нему; иначе откатываемся на старую логику по номеру в названии
 * (compareSectionNames). Так и числовой порядок 1..14 сохраняется, и
 * безымянные разделы («Дизайн и интерьер») можно перетащить в нужное место.
 */
export function makeSectionComparator(
  orderByName: Map<string, number>,
): (a: string, b: string) => number {
  return (a, b) => {
    const oa = orderByName.get(a);
    const ob = orderByName.get(b);
    if (oa != null && ob != null && oa !== ob) return oa - ob;
    if (oa != null && ob == null) return -1;
    if (oa == null && ob != null) return 1;
    return compareSectionNames(a, b);
  };
}
